import { ArrowLeft } from '@mui/icons-material'
import { Button, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { GreenText } from 'components'
import { NeedsClusterRemovedDetailsDto } from 'dtos'
import CheckInReviewItem from '../checkIn/CheckInReviewItem'
import { VehicleNeedsClusterRemovedPhotoProps } from './index'
import NeedsClusterRemovedStepper from './NeedsClusterRemovedStepper'

interface Step3PulledClusterReviewProps extends VehicleNeedsClusterRemovedPhotoProps {
  onBack: () => void
  onNext: () => void
  vehicleNeedsClusterRemovedDetails: NeedsClusterRemovedDetailsDto
  vehicleGuid?: string
}

export default function Step3PulledClusterReview({
  onBack,
  onNext,
  vehicleNeedsClusterRemovedDetails,
  vehicleGuid,
  pulledClusterPhoto,
  setPulledClusterPhoto
}: Step3PulledClusterReviewProps) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <NeedsClusterRemovedStepper activeStep={2} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <CheckInReviewItem
            complete={Boolean(pulledClusterPhoto.documentGuid)}
            label='Pulled Cluster Photo'
          />

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Typography variant='body1'>Notes: {pulledClusterPhoto.clusterPhotosPulledClusterPhotoNote}</Typography>
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Vehicle Check-In Steps:**

Displays the current step of the vehicle in the Needs Cluster 
Removed process.

---

**Pulled Cluster Check Mark:**

Displays a check mark to indicate that the Pulled Cluster Photo 
has been successfully uploaded.

---

**Notes:**

Displays any notes entered in the Capture Pulled Cluster Photo 
Dialog.

Notes entered in the "Needs Cluster Removed – Capture Pulled 
Cluster Photo" screen will also appear here.

---

**SUBMIT Button:**

Clicking this button will:

Upload the Pulled Cluster Photo and associate it with the 
vehicle record, including:

- The name of the user who completed the process.

- A date/time stamp.

Save any notes entered, which will appear under the Vehicle 
Details – Importer Notes (tab).

Return the user to the Needs Cluster Removed to-do list screen.

---

**PREVIOUS Button:**
Clicking this button will:

- Return the user to the previous step in the process.

---`}
            </GreenText>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' fullWidth onClick={onNext} type='submit' variant='contained'>
              SUBMIT
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
              PREVIOUS
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
